import React from "react";
import { Navigate } from "react-router-dom";
import { useClaims } from "../features/auth/useClaims";
import { paths } from "./paths";
import LoadingScreen from "../components/common/LoadingScreen";

/**
 * Gates a route by a Module.Action permission code (handoff §4: never
 * hardcode role names, always check the permissions array from the token).
 * `code` can also be an array - granted if the caller holds ANY one of them
 * (e.g. Guard Lookup's backend policy is "Attendance.Mark|Attendance.View").
 */
const PermissionRoute = ({ code, children }) => {
  const { isLoading, permissions } = useClaims();

  if (isLoading) {
    return <LoadingScreen />;
  }

  const codes = Array.isArray(code) ? code : [code];
  if (!codes.some((c) => permissions.includes(c))) {
    return <Navigate to={paths.dashboard} replace />;
  }

  return children;
};

export default PermissionRoute;
